// @ts-nocheck
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import globalConfig from '../../config/globalConfig';

const shouldHaveManifest = (pathname = '') => {
  if (pathname.startsWith('/app')) return true;
  return false;
};

const buildManifestUrl = (tripId = '') => {
  //const params = new URLSearchParams({ tripId });
  return `${globalConfig.axios.apiUrl}trips/${tripId}/appmanifest`;
};

const ManifestManager = () => {
  const { tripId } = useParams();
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;
    let link = document.querySelector('link[rel="manifest"]');
    const enabled = shouldHaveManifest(pathname);

    // Remove manifest and exit if not enabled
    if (!enabled) {
      if (link) link.remove();
      return;
    }

    const href = buildManifestUrl(tripId);

    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }

    link.href = href;
  }, [location, tripId]);

  return null;
};

export default ManifestManager;
